var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArhive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17423_88076)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F1F1F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0399 27.1795V17.1621C28.9696 17.168 28.8993 17.1719 28.829 17.1719H12.1718C12.1015 17.1719 12.0293 17.168 11.9609 17.1621V27.1795C11.9609 27.8257 12.4861 28.3509 13.1323 28.3509H27.8685C28.5147 28.3509 29.0399 27.8277 29.0399 27.1795ZM24.4129 21.0219C24.4129 21.346 24.1512 21.6076 23.8272 21.6076H17.1736C16.8496 21.6076 16.5879 21.346 16.5879 21.0219V19.4678C16.5879 19.1437 16.8496 18.8821 17.1736 18.8821H23.8252C24.1493 18.8821 24.4109 19.1437 24.4109 19.4678V21.0219H24.4129Z",
    fill: "#4251DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 14.8292V13.8198C30 13.1736 29.4749 12.6484 28.8286 12.6484H12.1714C11.5252 12.6484 11 13.1736 11 13.8198V14.8292C11 15.4032 11.4139 15.8815 11.9605 15.9811C12.0289 15.9928 12.0992 16.0006 12.1714 16.0006H28.8267C28.8989 16.0006 28.9692 15.9928 29.0375 15.9811C29.5861 15.8815 30 15.4032 30 14.8292Z",
    fill: "#4251DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17423_88076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArhive);
export default __webpack_public_path__ + "static/media/arhive.5ca6d96e5705387748eec91bb1882026.svg";
export { ForwardRef as ReactComponent };